<div class="phase-commands d-flex justify-content-end mb-5">
	<button
		type="button"
		itButton="primary"
		(click)="setCurrentPhase(phase.id)"
	>
		{{ "iterlex.set-current-phase" | translate }}
	</button>
	@if (phase.type !== "emendamento") {
		<button
			class="ms-3"
			type="button"
			itButton="secondary"
			(click)="createStepModal.toggle()"
		>
			{{ "iterlex.create-step" | translate }}
		</button>
	}
</div>

<it-tab-container
	[vertical]="phase.type !== 'emendamento'"
	(tabSelected)="changeTab($event)"
>
	@for (step of steps; track step.id) {
		<it-tab-item
			[id]="tabPrefix + step.id"
			[label]="step.label['iterlex.currentLanguage' | translate]"
			[active]="step.id === this.currentStepId"
			class="phase-step"
		>
			@if (phase.type === "emendamento") {
				<app-amendments
					[dossier]="dossier"
					[authority]="authority"
					[body]="body"
					[phase]="phase"
					[step]="step"
					[nextStep]="steps[$index + 1]"
					[active]="active && step.id === this.currentStepId"
					(setCurrentPhaseEvent)="setCurrentPhase($event)"
				/>
			} @else {
				<app-step
					[dossier]="dossier"
					[authority]="authority"
					[body]="body"
					[phase]="phase"
					[step]="step"
					[index]="$index"
					[active]="active && step.id === this.currentStepId"
					(setCurrentPhaseEvent)="setCurrentPhase($event)"
					(changeCurrentStepIdEvent)="changeCurrentStepId($event)"
					(deleteStepEvent)="deleteStepEvent($event)"
					(sendedToStagingAreaEvent)="sendedToStagingAreaEvent.emit()"
				/>
			}
		</it-tab-item>
	}
</it-tab-container>
<it-modal #createStepModal>
	<ng-container modalTitle>{{
		"iterlex.create-step" | translate
	}}</ng-container>
	<form #newStepForm="ngForm" (ngSubmit)="onCreateStepSubmit(newStepForm)">
		@if (phase.type === "commissione") {
			<it-select
				name="assignedBody"
				[label]="'iterlex.authority' | translate"
				ngModel
				required
			>
				<option selected value="">
					{{ "iterlex.select-authority" | translate }}
				</option>
				@for (commission of commissions; track commission.id) {
					<option [value]="commission.id">
						{{
							commission.label[
								"iterlex.currentLanguage" | translate
							]
						}}
					</option>
				}
			</it-select>
		} @else {
			<it-input
				type="text"
				name="descriptionITA"
				ngModel
				required
				[label]="
					('iterlex.title' | translate) +
					' (' +
					('iterlex.ita' | translate) +
					')'
				"
			></it-input>
			<it-input
				type="text"
				name="descriptionDEU"
				ngModel
				required
				[label]="
					('iterlex.title' | translate) +
					' (' +
					('iterlex.deu' | translate) +
					')'
				"
			></it-input>
		}
		<button
			itButton="primary"
			type="submit"
			[disabled]="!newStepForm.valid"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.create-step" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
